import {
  doc, getDoc, updateDoc, collection,
  addDoc, getDocs, query, orderBy,
  limit, serverTimestamp, increment, setDoc, deleteDoc,
} from 'firebase/firestore';
import { db } from '../firebase';

// --- User profile ---
export async function getUserProfile(uid) {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists() ? { id: snap.id, ...snap.data() } : null;
}

// --- Credits ---
export async function getCredits(uid) {
  const snap = await getDoc(doc(db, 'users', uid));
  return snap.exists() ? snap.data().credits : 0;
}

export async function deductCredits(uid, amount) {
  const ref = doc(db, 'users', uid);
  await updateDoc(ref, {
    credits: increment(-amount),
    creditsUsed: increment(amount),
  });
}

export async function addCredits(uid, amount) {
  await updateDoc(doc(db, 'users', uid), { credits: increment(amount) });
}

export async function setCredits(uid, amount) {
  await updateDoc(doc(db, 'users', uid), { credits: amount });
}

// --- Send logs ---
export async function logSend(uid, { subject, recipients, count, status, mode, htmlBody, fromEmail, fromName }) {
  await addDoc(collection(db, 'users', uid, 'logs'), {
    subject, recipients, count, status, mode,
    htmlBody: htmlBody || '',
    fromEmail: fromEmail || '',
    fromName: fromName || '',
    sentAt: serverTimestamp(),
  });
}

export async function getLogs(uid, maxResults = 100) {
  const q = query(collection(db, 'users', uid, 'logs'), orderBy('sentAt', 'desc'), limit(maxResults));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

// --- Drafts ---
export async function saveDraft(uid, draft) {
  if (draft.id) {
    await setDoc(doc(db, 'users', uid, 'drafts', draft.id), { ...draft, updatedAt: serverTimestamp() });
    return draft.id;
  } else {
    const ref = await addDoc(collection(db, 'users', uid, 'drafts'), { ...draft, updatedAt: serverTimestamp() });
    return ref.id;
  }
}

export async function getDrafts(uid) {
  const q = query(collection(db, 'users', uid, 'drafts'), orderBy('updatedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function deleteDraft(uid, draftId) {
  await deleteDoc(doc(db, 'users', uid, 'drafts', draftId));
}

// --- Admin: all users ---
export async function getAllUsers() {
  const snap = await getDocs(collection(db, 'users'));
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function updateUserRole(uid, role) {
  await updateDoc(doc(db, 'users', uid), { role });
}

export async function updateUserProfile(uid, data) {
  await updateDoc(doc(db, 'users', uid), data);
}

// --- App settings (admin managed) ---
export async function getAppSettings() {
  const snap = await getDoc(doc(db, 'settings', 'app'));
  return snap.exists() ? snap.data() : {
    fromNames: ['CM Fellowship Maharashtra', 'CMFP Team'],
    fromPrefixes: ['CMFellowship-Alert', 'CMFellowship-News', 'CMFP-Update'],
    replyTo: 'cmfellowship-mah@gov.in',
  };
}

export async function saveAppSettings(data) {
  await setDoc(doc(db, 'settings', 'app'), data, { merge: true });
}

// --- Saved CSVs ---
export async function saveCSV(uid, { name, contacts }) {
  const ref = await addDoc(collection(db, 'users', uid, 'csvLists'), {
    name,
    contacts,
    count: contacts.length,
    savedAt: serverTimestamp(),
  });
  return ref.id;
}

export async function getCSVLists(uid) {
  const q = query(collection(db, 'users', uid, 'csvLists'), orderBy('savedAt', 'desc'));
  const snap = await getDocs(q);
  return snap.docs.map(d => ({ id: d.id, ...d.data() }));
}

export async function deleteCSV(uid, csvId) {
  await deleteDoc(doc(db, 'users', uid, 'csvLists', csvId));
}
